import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {MetaDataHolder} from "../../../commons/types/meta-data-holder.type";
import {PreferencesDialogService} from "../../services/preferences-dialogs-service.service";
import {SettingsService} from "../../services/settings-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class preferencesMetaDataViewCtrl implements IController {

  metadata: any;

  public accountMetadata: any;
  public omsMetadata: any;
  public serviceMetadata: any;
  public taskMetadata: any;
  public fulfillmentMetadata: any;
  public thirdPartyServiceMetaData: any;
  public metaDataHolder: typeof MetaDataHolder = MetaDataHolder;
  public routeMetaData: any;
  public fulfillmentStepMetadata: any;

  /* @ngInject */
  constructor(private settingsService: SettingsService, private preferencesDialogService: PreferencesDialogService, private confirmDialogService: ConfirmDialogService, private $log) {
  }

  $onInit() {
    this._setMetaDataModels(this.metadata);
  }

  $onChanges(changes) {
    if (changes.metadata && !changes.metadata.isFirstChange()) {
      this._setMetaDataModels(this.metadata);
    }
  };


  onCreateMetadata($event, holder) {
    this.preferencesDialogService.metadataForm($event, holder)
      .then((metadataToCreate) => {
        this._createMetaData(metadataToCreate)
      })
  }

  onEditMetadata($event, holder, metadata) {
    this.preferencesDialogService.metadataForm($event, holder, metadata)
      .then((metadataToUpdate) => {
        this._updateMetaData(metadataToUpdate)
      })
  }

  onDeleteMetadata(id) {
    this.confirmDialogService.confirm('Delete Custom Title', 'Are you sure you want to delete the custom title?')
      .then(() => {
        this._deleteMetadata(id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  _deleteMetadata(id) {
    this.settingsService.deleteMetadata(id)
      .then((deletedMetadata) => {
        this.metadata = _.filter(this.metadata, (m) => {
          return m.id !== id;
        })
        this.$onInit();
      })
  }

  private _setMetaDataModels(metadata) {
    if (!metadata) {
      metadata = [];
    }
    this.accountMetadata = _.filter(metadata, (m) => {
      return m.holder === this.metaDataHolder.ACCOUNT;
    })
    this.omsMetadata = _.filter(metadata, (m) => {
      return m.holder === this.metaDataHolder.OMS;
    })
    this.serviceMetadata = _.filter(metadata, (m) => {
      return m.holder === this.metaDataHolder.SERVICE
    })
    this.taskMetadata = _.filter(metadata, (m) => {
      return m.holder === this.metaDataHolder.TASK
    })
    this.fulfillmentMetadata = _.filter(metadata, (m) => {
      return m.holder === this.metaDataHolder.FULFILLMENT
    })
    this.thirdPartyServiceMetaData = _.filter(metadata, (m) => {
      return m.holder === this.metaDataHolder.THIRDPARTYSERVICE
    })
    this.routeMetaData = _.filter(metadata, (m) => {
      return m.holder === this.metaDataHolder.ROUTE
    })
    this.fulfillmentStepMetadata = _.filter(metadata, (m) => {
      return m.holder === this.metaDataHolder.FULFILLMENT_STEP
    })
  }


  private _createMetaData(metadata) {
    this.settingsService.createMetadata(metadata)
      .then((createdMetadata) => {
        this.metadata = this.metadata.concat(createdMetadata);
        this._setMetaDataModels(this.metadata);
      })
  }

  private _updateMetaData(metadata) {
    this.settingsService.updateMetadata(metadata.id, metadata)
      .then((createdMetadata: any) => {
        const updatedIdx = _.findIndex(this.metadata, (m: any) => _.isEqual(m.id, createdMetadata.id));
        this.metadata[updatedIdx] = createdMetadata;
        // this.metadata = _.uniqBy(this.metadata.concat([createdMetadata]), 'id');
        this._setMetaDataModels(this.metadata);
      })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('preferencesMetaDataView', {
    bindings: {
      metadata: '<'
    },
    template: require('./preferences-meta-data-view.html').default,
    controller: preferencesMetaDataViewCtrl
  });
